import { MaterialTypes_T, MaterialTypeInfo } from "./material-types.js";

const MaterialFullTypeKeyData = [
    { type: MaterialTypes_T.Basic },
    { type: MaterialTypes_T.Lambert },
    { type: MaterialTypes_T.Phong },
    { type: MaterialTypes_T.PBR, materialType: "pbr" },
    { type: MaterialTypes_T.PBR, materialType: "nested" },
    { type: MaterialTypes_T.PBR, materialType: "basic" },
    { type: MaterialTypes_T.Points },
    { type: MaterialTypes_T.LineBasic },
    { type: MaterialTypes_T.Sprite },
];

const Unrecognized = Symbol("Unrecognized");

const keys = new Map();
const MaterialFullTypes = [];

const keyArray = [];

function getKeyString({ type, materialType }) {
    keyArray[0] = MaterialTypeInfo[type].name;

    if (type === MaterialTypes_T.PBR) {
        materialType = materialType || "pbr";
        keyArray[1] = materialType;
    } else {
        keyArray.length = 1;
    }

    return keyArray.join("; ");
}

for (const keyData of MaterialFullTypeKeyData) {
    const keyStr = getKeyString(keyData);
    const key = Symbol(keyStr);
    keys.set(keyStr, key);
    MaterialFullTypes.push(key);
}

function getMaterialFullTypeKey(materialData) {
    if (!materialData) {
        return Unrecognized;
    }

    const { type, materialType } = materialData;

    if (!(type in MaterialTypeInfo)) {
        return Unrecognized;
    }

    const keyStr = getKeyString(materialData);
    const key = keys.get(keyStr) || Unrecognized;
    return key;
}

export { MaterialFullTypes, getMaterialFullTypeKey, Unrecognized };
